module.exports = __webpack_public_path__ + "img/PPT版_01.fa70465f.png";